import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://discord.com/api/oauth2/authorize?client_id=848139683929128961&permissions=8&scope=bot"
          target="_blank"
          rel="noopener noreferrer"
        >
          BOT INVITE
        </a>
      </header>
    </div>
  );
}

export default App;
